import React, { Component } from 'react'
import classes from './TDSTransactiondetails.module.css'
import axios from '../../../axios-order'
import ErrorIcon from '@material-ui/icons/Error'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Card from '../../../components/ui/Cards'
import PublishIcon from '@material-ui/icons/Publish'
import GetAppIcon from '@material-ui/icons/GetApp'
import DataTables from 'material-ui-datatables'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import tdsTemplate from '../../../asserts/templates/TDS_transaction_details.xlsx'
import ClearIcon from '@material-ui/icons/Clear'
import Snackbar from '@material-ui/core/Snackbar'
import Alert from '@material-ui/lab/Alert'
import BoxWrapper from '../../../components/ui/boxWrapper'
import RefreshIcon from '@mui/icons-material/Refresh'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import TextField from "@material-ui/core/TextField";
import { TablePagination } from "@material-ui/core";
import RightDrawer from "../../../components/ui/RightDrawer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { withRouter } from 'react-router-dom';
import { canWrite } from "../../../utils/privilegeUtils";

class TDSTransactionDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      read_only: '',
      file_value: null,
      total_records: 0,
      successful_records: 0,
      errorPage: 1,
      perErrorPages: 10,
      errortotal: 0,
      error_records: 0,
      sellerCustomerCol: [
        {
          label: 'Employee ID',
          render: (name, all) => all['record']['erp_code'] || 'N/A'
        },
        {
          label: 'Employee Name',
          render: (name, all) => all['record']['name'] || 'N/A'
        },
        { key: 'row', label: 'Row #' },
        {
          label: 'Errors',
          render: (name, all) => {
            return Object.keys(all['errors_in']).map((i, v) => (
              <div key={v} style={{ whiteSpace: 'pre-wrap' }}>
                <span>{i}</span> <span>:</span>{' '}
                <span style={{ color: 'red' }}>
                  {all['errors_in'][i].join(',')}
                </span>
              </div>
            ))
          }
        }
      ],
      sellerCustomerData: [],
      error: null,
      showUploadData: false,
      snackbarOpen: false,
      snackbarMessage: '',
      snackbarSeverity: 'success',
      uploadHistoryTableData: [],
      erpDataExportLoading: false,
      allTransactionData: [],
      OriginalDataAllTransactionData: [],
      showTransactionDrawer: false,
      showTransactionData: {},
      transactionPage: 0,
      transactionRowsPerPage: 25,
      transactionRowCount: 0,
      transactionSearchInput: "",
      loaderForTransaction: true,
    }
  }

  handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.setState({ snackbarOpen: false })
  }

  getHistoryTableUploadData = async () => {
    try {
      const response = await axios.get(
        `/arc/get_data_upload_history/${localStorage.getItem(
          'business_entity_id'
        )}/23`
      )
      const data = response?.data?.record || []
      if (data.length > 0) {
        localStorage.setItem('tds_upload_history_id', data[0].id)
      }
      this.setState({
        uploadHistoryTableData: data,
        snackbarOpen: false
      })
    } catch (error) {
      console.error('Error fetching upload history:', error)
      this.setState({
        uploadHistoryTableData: [],
        snackbarOpen: true,
        snackbarMessage:
          error.response?.data?.message ||
          'Failed to fetch upload history data',
        snackbarSeverity: 'error'
      })
    }
  }

  getTransactionDataApi = (event, searchIn) => {
    axios
      .post(`/get_tds_transaction_by_business_entity`, {
        number_of_rows_per_page: this.state.transactionRowsPerPage,
        page_number: this.state.transactionPage,
        search_text: searchIn,
        business_entity_id: localStorage.getItem("business_entity_id"),
      })
      .then((res) => {
        this.setState({
          allTransactionData: res.data.records,
          OriginalDataAllTransactionData: res.data.records,
          transactionRowCount: res.data.row_count,
          loaderForTransaction: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loaderForTransaction: false });
      });
  };

  handleTransactionChangePage = (event, newPage) => {
    this.setState({ transactionPage: newPage }, () => {
      this.getTransactionDataApi(event, this.state.transactionSearchInput);
    });
  };

  handleTransactionChangeRowsPerPage = (event) => {
    this.setState({ transactionRowsPerPage: +event.target.value, transactionPage: 0 }, () => {
      this.getTransactionDataApi(event, this.state.transactionSearchInput);
    });
  };

  handleTransactionSearchInputChange = (event) => {
    this.setState({ transactionSearchInput: event.target.value, transactionPage: 0 }, () => {
      this.getTransactionDataApi(event, this.state.transactionSearchInput);
    });
  };
  showTransactionToggleDrawerClose = (event) => {
    this.setState({ showTransactionDrawer: false, showTransactionData: {} });
  };

  transaction_TableHeader() {
    const tableHeader = [
      "Employee ID",
      "Pan",
      "Name",
      "Payment Date",
      "Payment Amount",
      "Tax Amount",
      "Show",
    ];
    return tableHeader.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }
  transaction_data() {
    const showTransactionToggleDrawer = (transactionData) => {
      this.setState({
        showTransactionData: transactionData,
        showTransactionDrawer: true,
      });
    };

    if (this.state.allTransactionData && this.state.allTransactionData.length >= 1) {
      return this.state.allTransactionData.map((tableData, index) => {
        const tdsAmount = tableData.tds_amount !== null && tableData.tds_amount !== undefined ? tableData.tds_amount : 0;
        const surcharge = tableData.surcharge !== null && tableData.surcharge !== undefined ? tableData.surcharge : 0;
        const healthEducationCess = tableData.health_education_cess !== null && tableData.health_education_cess !== undefined ? tableData.health_education_cess : 0;
        const totalTaxAmount = tdsAmount + surcharge + healthEducationCess;
        return (
          <tr key={index}>
            <td>{tableData.erp_code || "N/A"}</td>
            <td>{tableData.pan || "N/A"}</td>
            <td>{tableData.name || "N/A"}</td>
            <td>{tableData.payment_date || "N/A"}</td>
            <td>{tableData.payment_amount !== null && tableData.payment_amount !== undefined ? tableData.payment_amount : "N/A"}</td>
            <td>{totalTaxAmount}</td>
            <td>
              <RemoveRedEyeOutlinedIcon
                className="action-icon-button showIcon"
                onClick={() => showTransactionToggleDrawer(tableData)}
              />
            </td>
          </tr>
        );
      });
    } else if (this.state.loaderForTransaction) {
      return (
        <tr>
          <td
            style={{ color: "black", textAlign: "center", fontWeight: "bold" }}
            colSpan={7}
          >
            Loading...Please wait
          </td>
        </tr>
      );
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colSpan={7}>
            No data found!
          </td>
        </tr>
      );
    }
  }

  componentDidMount() {
    console.log('Calling getHistoryTableUploadData')
    this.getHistoryTableUploadData()
    this.getTransactionDataApi()
  }

  fileUploader = event => {
    const file = event.target.files[0]
    if (!file) {
      this.setState({
        snackbarOpen: true,
        snackbarMessage: 'No file selected',
        snackbarSeverity: 'error'
      })
      return
    }

    if (!file.name.endsWith('.xlsx')) {
      this.setState({
        snackbarOpen: true,
        snackbarMessage: 'Please upload an .xlsx file',
        snackbarSeverity: 'error'
      })
      return
    }

    const reader = new FileReader()
    reader.onload = async () => {
      try {
        const file_value = reader.result
        await axios.post(`/tds_transaction_details`, {
          file: file_value,
          business_entity_id: parseInt(
            localStorage.getItem('business_entity_id')
          )
        })
        this.getHistoryTableUploadData()
        this.getTransactionDataApi()
        this.setState({
          snackbarOpen: true,
          snackbarMessage: 'File uploaded successfully',
          snackbarSeverity: 'success'
        })
      } catch (error) {
        console.error('Error uploading file:', error)
        this.setState({
          error: error?.response?.data?.message || 'File upload failed',
          total_records: 0,
          snackbarOpen: true,
          snackbarMessage:
            error?.response?.data?.message || 'File upload failed',
          snackbarSeverity: 'error'
        })
      }
    }
    reader.onerror = () => {
      this.setState({
        snackbarOpen: true,
        snackbarMessage: 'Error reading file',
        snackbarSeverity: 'error'
      })
    }
    reader.readAsDataURL(file)
  }

  refreshUploadHistoryTable = () => {
    this.getHistoryTableUploadData()
    this.getTransactionDataApi();
  }

  CollectionListActions = () => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div>
        {(localStorage.getItem('is_uploads') !== "N") && (
          <>
            <a
              href={tdsTemplate}
              download='TDS Transaction Details Template.xlsx'
              style={{ textDecoration: 'none' }}
            >
              <Button component='label' size='small' color='primary'>
                <GetAppIcon style={{ fontSize: '20px' }} />
                DOWNLOAD TEMPLATE
              </Button>
            </a>

            {canWrite("TDS-FILING 24Q") && (
            <Button component='label' size='small' color='primary'>
              <PublishIcon style={{ fontSize: '20px' }} />
              UPLOAD TEMPLATE
              <input
                accept='.xlsx'
                name='file'
                type='file'
                value=''
                hidden
                onChange={this.fileUploader}
              />
            </Button>
            )}
          </>
        )}
      </div>

      <Button
        component='label'
        size='small'
        color='primary'
        style={{ float: 'right' }}
        onClick={this.refreshUploadHistoryTable}
      >
        <RefreshIcon style={{ fontSize: '20px' }} />
        Refresh
      </Button>
    </div>
  )

  closeUploadData = () => {
    this.setState({ showUploadData: false })
  }

  downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`
    const downloadLink = document.createElement('a')
    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click()
  }

  handleNextPage = event => {
    const { errorPage, perErrorPages, errortotal } = this.state
    const totalPages = Math.ceil(errortotal / perErrorPages)

    if (errorPage < totalPages) {
      const newPage = errorPage + 1
      console.log(`Navigating to page ${newPage}`)
      this.setState({ errorPage: newPage }, () => {
        this.uploadReport(null, newPage)
      })
    }
  }

  handlePreviousPage = event => {
    const { errorPage } = this.state

    if (errorPage > 1) {
      const newPage = errorPage - 1
      console.log(`Navigating to page ${newPage}`)
      this.setState({ errorPage: newPage }, () => {
        this.uploadReport(null, newPage)
      })
    }
  }

  handleRowsPerPageChange = (index, value) => {
    console.log(`Changing rows per page to ${value}`)
    this.setState(
      {
        perErrorPages: value,
        errorPage: 1
      },
      () => {
        this.uploadReport(null, 1)
      }
    )
  }

  uploadReport = (id, pageParam = null) => {
    let currentId = id
    if (!currentId) {
      currentId = localStorage.getItem('tdsUploadReportId')
    }

    if (!currentId) {
      console.error('uploadReport: Invalid ID', currentId)
      this.setState({ error: 'Invalid ID', loading: false })
      return
    }

    localStorage.setItem('tdsUploadReportId', currentId)

    const page = pageParam !== null ? pageParam : this.state.errorPage
    const perErrorPages = this.state.perErrorPages || 10

    if (page < 1 || !Number.isInteger(page)) {
      console.error('uploadReport: Invalid page number', page)
      this.setState({ error: 'Invalid page number', loading: false })
      return
    }

    if (perErrorPages < 1 || !Number.isInteger(perErrorPages)) {
      console.error('uploadReport: Invalid rows per page', perErrorPages)
      this.setState({ error: 'Invalid rows per page', loading: false })
      return
    }

    console.log(
      `Calling API with id: ${currentId}, page: ${page}, perErrorPages: ${perErrorPages}`
    )

    this.setState({ loading: true, error: null })

    axios
      .get(`/arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`)
      .then(response => {
        console.log('API Response:', JSON.stringify(response.data, null, 2))
        const res = response.data.records

        if (
          res.type === 'json' &&
          res.records &&
          Array.isArray(res.records.details)
        ) {
          const error_records = res.records.details.filter(
            v => v.status === 'Fail'
          )
          this.setState({
            showUploadData: true,
            uploadStatusFail: res.records,
            total_records: parseInt(res.records.summary?.total_records) || 0,
            successful_records:
              parseInt(res.records.summary?.valid_records) || 0,
            error_records: parseInt(res.records.summary?.invalid_records) || 0,
            errortotal: parseInt(response.data.total) || 0,
            errorPage: parseInt(response.data.page) || page,
            perErrorPages: parseInt(response.data.per_page) || perErrorPages,
            sellerCustomerData: error_records,
            error: null,
            loading: false
          })
        } else if (res.type === 'message') {
          this.setState({
            showUploadData: true,
            uploadStatusFail: res,
            total_records: 0,
            successful_records: 0,
            error_records: 0,
            errortotal: parseInt(response.data.total) || 0,
            errorPage: parseInt(response.data.page) || page,
            perErrorPages: parseInt(response.data.per_page) || perErrorPages,
            sellerCustomerData: [],
            error: res.message,
            loading: false
          })
        } else {
          console.warn('Invalid response format:', res)
          this.setState({
            error: 'Invalid response format',
            total_records: 0,
            loading: false
          })
        }
      })
      .catch(error => {
        console.error('API Error:', error.response || error.message)
        this.setState({
          loading: false,
          error: `Failed to fetch data: ${error.message}`
        })
      })
  }

  onClickExportTDSTransactionDetails = async () => {
    this.setState({ erpDataExportLoading: true })
    try {
      const response = await axios.get(
        `/generate_tds_transaction_excel_report/${localStorage.getItem(
          'business_entity_id'
        )}`
      )
      const contentType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const filename = `TDS Transaction Details 1.xlsx`
      this.downloadBase64File(contentType, response.data.file, filename)
      this.setState({
        snackbarOpen: true,
        snackbarMessage: 'Exported successfully',
        snackbarSeverity: 'success'
      })
    } catch (error) {
      console.error('Error exporting to Excel:', error)
      this.setState({
        snackbarOpen: true,
        snackbarMessage:
          error?.response?.data?.message || 'Failed to export to Excel',
        snackbarSeverity: 'error'
      })
    } finally {
      this.setState({ erpDataExportLoading: false })
    }
  }

  render() {
    return (
      <React.Fragment>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            padding: '4px 0px',
            marginBottom: '6px',
          }}
        >
          <Tooltip title="Back" arrow>
            <IconButton
              onClick={() => this.props.history.push('/Data-Upload')}
              sx={{
                borderRadius: '50%',
                padding: '6px',
                color: '#263238',
                backgroundColor: '#ffffff',
                height: '36px',
                width: '36px',
                '&:hover': {
                  backgroundColor: '#455a64',
                  color: '#ffffff',
                },
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                transition: 'background-color 0.3s ease',
              }}
            >
              <ArrowBackIcon sx={{ fontSize: '20px' }} />
            </IconButton>
          </Tooltip>
        </Box>
        <>
          <div>
            <BoxWrapper boxTitle='Upload TDS Transaction Details'>
              <>
                <div style={{ marginBottom: '10px' }}>
                  <this.CollectionListActions />
                </div>
                <div className='responsive-table'>
                  <table className='custome-table'>
                    <thead>
                      <tr>
                        <th>Last Upload Date & Time</th>
                        <th>Status</th>
                        <th>Upload Type</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(Array.isArray(this.state.uploadHistoryTableData)
                        ? this.state.uploadHistoryTableData
                        : []
                      ).map((item, i) => {
                        const isDisabled =
                          item.status === 'Initiated' ||
                          item.status === 'In Progress' ||
                          item.status === 'Uploaded'

                        return (
                          <tr key={i}>
                            <td>{item.upload_date}</td>
                            <td>{item.status}</td>
                            <td>{item.upload_type}</td>
                            <td>
                              <RemoveRedEyeOutlinedIcon
                                className={
                                  isDisabled
                                    ? 'action-icon-button-disabled'
                                    : 'action-icon-button showIcon'
                                }
                                color={isDisabled ? 'disabled' : 'inherit'}
                                onClick={
                                  isDisabled
                                    ? undefined
                                    : () => this.uploadReport(item.id)
                                }
                                style={{
                                  cursor: isDisabled ? 'not-allowed' : 'pointer'
                                }}
                              />
                            </td>
                          </tr>
                        )
                      })}
                      {(!Array.isArray(this.state.uploadHistoryTableData) ||
                        this.state.uploadHistoryTableData.length === 0) && (
                          <tr>
                            <td
                              colSpan={4}
                              style={{ color: 'red', textAlign: 'center' }}
                            >
                              No Data Found!
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                </div>
              </>
            </BoxWrapper>
          </div>

          {this.state.showUploadData ? (
            <>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <div className={classes.Main_frame}>
                    <div className={classes.form_title_bar}>
                      <div className='form_title_name'>
                        <ul
                          style={{
                            listStyle: 'none',
                            marginBottom: '0px',
                            padding: '0px',
                            marginTop: '0px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                        >
                          <li style={{ fontWeight: '700' }}>Upload Details</li>
                          <li>
                            <button
                              className='close-icon-button'
                              onClick={this.closeUploadData}
                            >
                              <ClearIcon
                                style={{ color: 'var(--app-bar-bg)' }}
                              />
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className={classes.form_body_part}>
                      {this.state.total_records > 0 && (
                        <div>
                          <div
                            style={{ marginLeft: '30px', marginRight: '30px' }}
                          >
                            <Grid container spacing={3}>
                              <Grid item xs={4}>
                                <Card
                                  backgroundcolor='#6f9eaf'
                                  cardTitle='Total Records'
                                  cardBody={this.state.total_records}
                                />
                              </Grid>
                              <Grid item xs={4}>
                                <Card
                                  backgroundcolor='#007965'
                                  cardTitle='Successful Records'
                                  cardBody={this.state.successful_records}
                                />
                              </Grid>
                              <Grid item xs={4}>
                                <Card
                                  backgroundcolor='#eb596e'
                                  cardTitle='Error Records'
                                  cardBody={this.state.error_records}
                                />
                              </Grid>
                            </Grid>
                          </div>

                          <div
                            style={{
                              height: '300',
                              margin: '20px 30px 0px 30px'
                            }}
                          >
                            <Grid container spacing={3}>
                              <Grid item xs={12}>
                                <div
                                  sx={{
                                    height: 300,
                                    mt: 2,
                                    overflowY: 'auto',
                                    overflowX: 'auto'
                                  }}
                                >
                                  <MuiThemeProvider>
                                    <DataTables
                                      columns={this.state.sellerCustomerCol}
                                      data={this.state.sellerCustomerData}
                                      selectable={false}
                                      showRowHover={true}
                                      page={this.state.errorPage}
                                      count={this.state.errortotal}
                                      rowSize={this.state.perErrorPages}
                                      showRowSizeControls={true}
                                      showFooterToolbar={true}
                                      onNextPageClick={this.handleNextPage}
                                      onPreviousPageClick={
                                        this.handlePreviousPage
                                      }
                                      onRowSizeChange={
                                        this.handleRowsPerPageChange
                                      }
                                    />
                                  </MuiThemeProvider>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                      )}
                      {this.state.error && (
                        <div style={{ color: 'red' }}>
                          <ErrorIcon />
                          {this.state.error}
                        </div>
                      )}
                    </div>
                  </div>
                </Grid>
              </Grid>
            </>
          ) : (
            ''
          )}
          <BoxWrapper
            boxTitle="TDS Transaction Details"
            exportToExcelEnable={true}
            exportToExcelFn={this.onClickExportTDSTransactionDetails}
            loadingexcel={this.state.erpDataExportLoading}
            enableSearchInput={true}
            searchInputPlaceholder="Search..."
            searchInputOnchange={this.handleTransactionSearchInputChange}
            searchInputValue={this.state.transactionSearchInput}
          >
            <>
              <div className="responsive-table">
                <table className="custome-table">
                  <tbody>
                    <tr>{this.transaction_TableHeader()}</tr>
                    {this.transaction_data()}
                  </tbody>
                </table>
              </div>
              <TablePagination
                rowsPerPageOptions={[25, 100, 500, 1000, 3000]}
                component="div"
                count={this.state.transactionRowCount}
                rowsPerPage={this.state.transactionRowsPerPage}
                page={this.state.transactionPage}
                onPageChange={this.handleTransactionChangePage}
                onRowsPerPageChange={this.handleTransactionChangeRowsPerPage}
              />
            </>
          </BoxWrapper>

          <RightDrawer
            drawerName="TDS Transaction Details"
            open={this.state.showTransactionDrawer}
            onClose={this.showTransactionToggleDrawerClose}
            style={{ width: 500 }}
          >
            {Object.keys(this.state.showTransactionData).length > 0 && (
              <>
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="GSTIN"
                  value={this.state.showTransactionData.entity_gstin || ""}
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Branch Name"
                  value={this.state.showTransactionData.branch_name || ""}
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Voucher ID"
                  value={this.state.showTransactionData.voucher_id || ""}
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Transaction Date"
                  value={this.state.showTransactionData.transaction_date || ""}
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Surcharge"
                  value={this.state.showTransactionData.surcharge !== null && this.state.showTransactionData.surcharge !== undefined ? this.state.showTransactionData.surcharge : ""}
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Health and Education Cess"
                  value={this.state.showTransactionData.health_education_cess !== null && this.state.showTransactionData.health_education_cess !== undefined ? this.state.showTransactionData.health_education_cess : ""}
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="TDS Amount"
                  value={this.state.showTransactionData.tds_amount !== null && this.state.showTransactionData.tds_amount !== undefined ? this.state.showTransactionData.tds_amount : ""}
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Nature of Payment"
                  value={this.state.showTransactionData.nature_of_payment || ""}
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Created Date"
                  value={this.state.showTransactionData.created_date || ""}
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Modified Date"
                  value={this.state.showTransactionData.modified_date || ""}
                />
              </>
            )}
            <button
              type="button"
              className="button-outlined-secondary mt-20"
              onClick={this.showTransactionToggleDrawerClose}
            >
              close
            </button>
          </RightDrawer>
          <Snackbar
            open={this.state.snackbarOpen}
            autoHideDuration={5000}
            onClose={this.handleSnackbarClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <Alert
              onClose={this.handleSnackbarClose}
              severity={this.state.snackbarSeverity}
              sx={{ width: '100%' }}
            >
              {this.state.snackbarMessage}
            </Alert>
          </Snackbar>
        </>
      </React.Fragment>
    )
  }
}

export default withRouter(TDSTransactionDetails);
